export default ({transaction: {description = ''} = {}} = {}) => description;
